import * as types from '../mutation_types';

export default {
  [types.SET_SDG_PROJECTS] (state, value) {
    state.projects = value;
  },

  [types.SET_SDG_IDENTIFIER] (state, value) {
    state.sdgIdentifier = value;
  },

  [types.SET_SDG_NUM_PROJECTS] (state, value) {
    state.sdgNumProjects = value;
  },

  [types.SET_SDG_COMMUNITY] (state, value) {
    state.sdgCommunity = value;
  },

  [types.SET_SDG_RAISED] (state, value) {
    state.sdgRaised = value;
  },

  [types.SET_SDG_NEXT] (state, value) {
    state.nextPage = value;
  },

  [types.SET_SDG_CURRENT_PAGE] (state, value) {
    state.currentPage = value;
  },

  [types.SET_SDG_PREV] (state, value) {
    state.prevPage = value;
  },

  [types.SET_SDG_COUNT] (state, value) {
    state.count = value;
  },
};
